import { Button, Grid, Box, IconButton, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, TextField } from '../../../../../../components';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

export const EmrTestItemDetail = ({ onClose, onAdd }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        emr_item_help: Yup.string().required('Emr Item Help is required'),
        left_value: Yup.string().required('Left Value is required'),
        right_value: Yup.string().required('Right Value is required')
      })
    ),
    mode: 'all'
  });

  const { handleSubmit, setValue, watch } = methods;

  const onSubmit = (e, data) => {
    e.preventDefault();
    onAdd(data);
    console.log(data);
  };

  return (
    <Stack spacing={2} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold" textAlign="center">
          Add Item Detail
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider methods={methods} sx={{ height: '100%', overflow: 'auto' }}>
        <form onSubmit={handleSubmit(onSubmit)} style={{ height: '100%' }}>
          <Grid container spacing={2} sx={{ flex: 1, height: '100%', alignItems: 'center' }}>
            <Grid item xs={12}>
              <Stack spacing={2}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>Emr Item Help</Typography>
                  <TextField name="emr_item_help" sx={{ flex: 1 }} placeholder="Enter Item Help Name" fullWidth />
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography sx={{ flex: 0.3, fontSize: '1.4rem' }}>Left Value/Right Value</Typography>
                  <TextField name="left_value" sx={{ flex: 0.5 }} placeholder="Left Value" fullWidth />
                  <TextField name="right_value" sx={{ flex: 0.5 }} placeholder="Right Value" fullWidth />
                </Stack>
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                  <Button onClick={(e) => onSubmit(e)} variant="contained" sx={{ minWidth: 'auto', p: 1 }}>
                    <Typography>Add</Typography>
                  </Button>
                  <Button variant="contained" sx={{ minWidth: 'auto', p: 1 }} onClick={onClose}>
                    <Typography>Exit</Typography>
                  </Button>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </Stack>
  );
};
